export default __webpack_public_path__ + "static/media/1942.14a554ce.png";